// extracted by mini-css-extract-plugin
export default {"Navbar2_maindiv":"Navbar2_Navbar2_maindiv__tJ1MB"};